import $ from 'jquery';
import throttle from './throttle';

$(document).ready(function() {
  if ($('.social-mod').length) {
    initSocialModule();
  }

  function initSocialModule() {
    var $win = $(window),
      $socialModule = $('.social-mod'),
      articlePos = $('.news-entry').offset().top,
      fixPoint = articlePos - 15;

    var socialModScrollCheck = throttle(function() {
      if ($win.scrollTop() > fixPoint) {
        $socialModule.addClass('is-fixed');
      } else {
        $socialModule.removeClass('is-fixed');
      }
    }, 10);

    $win.scroll(socialModScrollCheck);
    $('.socialModule-shareOption').hover(
      function() {
        $(this)
          .find('.socialModule-slideOut')
          .addClass('is-visible');
      },
      function() {
        $(this)
          .find('.socialModule-slideOut')
          .removeClass('is-visible');
      }
    );

    $('.socialModule-shareOption').click(function(event) {
      event.preventDefault();

      const $this = $(this);

      // Set values for window
      let intWidth = intWidth || '500';
      let intHeight = intHeight || '400';

      // Set title and open popup with focus on it
      let strTitle = $this.attr('title') || 'Social Share';
      let strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=yes';
      window.open($this.attr('href'), strTitle, strParam);
    });

    $('a.video-wrapper').click(function(event) {
      event.preventDefault();
      var video_source = $(this)
        .attr('href')
        .split('=')
        .pop();
      var video_height = $(this)
        .children('.big-img')
        .height();
      $(this)
        .children('.big-img')
        .css('background', 'black')
        .html(
          '<iframe width="618" height="' +
            video_height +
            '" src="https://www.youtube.com/embed/' +
            video_source +
            '?autoplay=1&rel=0&modestbranding=1&showin" frameborder="0" allowfullscreen></iframe>'
        );
    });
  }
});
